/** @format */

import React, { useState, useRef } from 'react';
import { PageContainer, FilterPod, TableComponents, Icons } from 'components';
import { toFilterVOS, filterVOStoQueryStr } from 'components/FilterPod';
import { makeStyles } from '@mui/styles';
import { Grid, Button, Menu, MenuItem, Box } from '@mui/material';
import LoanServices from '../services/LoanServices';
import InitFilters from './constants/InitFiltering';
import { columns, generateData } from './components/Columns';
import LoanInstallmentDialog from './LoanInstallment';
import { useNavigate } from 'react-router-dom';
import FilterButton from 'components/FilterPod/FilterButton';
import { getDynamicObjectAction, constBreadCrumbsTitle } from 'utility';
import { useCurrencyUnit } from 'hooks';
import axios from 'axios';
export default function RecivedLoan() {
  // -- STATES --//
  const tableRef = useRef();
  const [loading, setLoading] = useState(false);
  const [, setFilterParams] = useState(null);
  const [size, setSize] = useState(10);
  const [page, setPage] = useState(0);
  const currencyText = useCurrencyUnit();
  const [filters, setFilters] = useState(InitFilters(currencyText));

  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const handleCloseFilterDialog = () => setOpenFilterDialog(false);

  // --HOOKS--//
  const classes = useStyles();
  /**
   * لیست اکشن ها رو برمیگرداند . به ازای هر اکشن ، درصورتیکه دسترسی داشته باشد ترو و دسترسی نداشته باشد فالز است
   */
  const actionsList = getDynamicObjectAction(['loanListPage', 'loanDetailAction', 'loanPayAction']);
  // --API REQUESTS--//
  const getDicsountCodes = async (query) => {
    try {
      setLoading(true);
      const orderBy = [];
      const filter = toFilterVOS([...filters]);
      const queries = filterVOStoQueryStr(filter);
      const params = {
        offset: query ? query?.pageNumber * query?.pageSize : page * size,
        size: query ? query?.pageSize : size,
        ...queries,
      };

      const data = {
        filterVOS: filter ?? [],
        parentParams: [],
        orderByElementVOS: orderBy ?? [],
      };

      setFilterParams({ data, params });

      const res = await LoanServices.getUserLoanList(params);

      let list = [];
      if (res.result) {
        list = generateData(res.result, {
          page: query ? query?.pageNumber : page,
          pageSize: query?.pageSize || size,
        });
      }
      const d = {
        data: list,
        page: query ? query?.pageNumber : page,
        totalCount: res?.count,
      };

      setLoading(false);
      return d; // passed to MaterialTable
    } catch (error) {
      if (axios.isCancel(error)) {
        setLoading(true);
      } else {
        setLoading(false);
        return {
          data: [],
          page: query ? query?.pageNumber : page,
          totalCount: 0,
        };
      }
    }
  };

  // -- OTHER FUNCTIONS --//
  const onFiltersChange = (newFilters) => {
    setFilters(newFilters);
    setPage(0);
    setSize(10);
    setTimeout(() => {
      tableRef?.current?.onChangeTable(true);
    }, 100);
  };

  const hint = 'در این بخش می‌توانید لیست تسهیلات دریافتی را مشاهده کنید.';

  return (
    <PageContainer
      title="تسهیلات دریافتی"
      description={hint}
      breadcrumbs={constBreadCrumbsTitle.LOAN_INVOICE}
      className={classes.root}
    >
      {actionsList['loanListPage'] && (
        <>
          <Grid item xs={12}>
            <Box
              display="flex"
              justifyContent="end"
              alignItems="flex-end"
              style={{ marginBottom: 16 }}
            >
              <FilterButton setOpenFilterDialog={setOpenFilterDialog} filters={filters} />
            </Box>
            <Box>
              <FilterPod
                filters={filters}
                onChange={onFiltersChange}
                openFilterDialog={openFilterDialog}
                setOpenFilterDialog={setOpenFilterDialog}
                handleCloseFilterDialog={handleCloseFilterDialog}
              />
            </Box>
          </Grid>
          {currencyText && (
            <TableComponents
              data={getDicsountCodes}
              columns={columns(SeeDetailBtn, actionsList, currencyText)}
              isLoading={loading}
              ref={tableRef}
              onChange={(ps) => {
                setPage(ps?.pageNumber);
                setSize(ps?.pageSize);
                return getDicsountCodes(ps);
              }}
            />
          )}
        </>
      )}
    </PageContainer>
  );
}

function SeeDetailBtn({ rd, tableRef, actionsList }) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [openDialog, setOpenDialog] = useState(false);

  const classes = useStyles();
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (event) => {
    setAnchorEl(null);
  };
  const navigate = useNavigate();

  return (
    <div className={classes.otherActions}>
      <Button
        aria-controls="guild-other-actions"
        aria-haspopup="true"
        endIcon={<Icons icon="CaretDown" color="#343434" size="22" />}
        onClick={handleClick}
        variant="contained"
        className={classes.expandBtn}
      >
        عملیات
      </Button>
      <Menu
        className={classes.otherActionsMenu}
        id="guild-other-actions"
        keepMounted
        open={Boolean(anchorEl)}
        anchorEl={anchorEl}
        elevation={2}
        onClose={handleClose}
      >
        {actionsList['loanPayAction'] && (
          <MenuItem
            className={classes.otherActionsMenuItem}
            onClick={() => {
              navigate(`/Loan/${rd.id}/details?isUser=true`);
            }}
          >
            جزییات قرارداد
          </MenuItem>
        )}
        {actionsList['loanDetailAction'] && (
          <MenuItem
            className={classes.otherActionsMenuItem}
            onClick={() => {
              setOpenDialog(true);
              setAnchorEl(null);
            }}
          >
            مشاهده و پرداخت اقساط
          </MenuItem>
        )}
      </Menu>
      <LoanInstallmentDialog open={openDialog} setOpen={setOpenDialog} loan={rd}/>
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTable-root': {
      border: 'solid 1px rgba(109, 114, 120, 0.18)',
      borderRadius: 4,
    },
    '& .MuiTableRow-head th:first-child': {
      borderTopLeftRadius: 4,
    },
    '& .MuiTableRow-head th:last-child': {
      borderTopRightRadius: 4,
      width: 145,
    },
  },
  props: {
    padding: theme.spacing(2, 3),
    boxSizing: 'border-box',
  },
  tickIcon: {
    color: '#43A047',
    fontSize: 17,
  },
  tickItem: {
    marginBottom: theme.spacing(1),
  },
  propsTitle: {
    color: '#2b3940',
    fontWeight: 'bold',
    fontSize: 12,
    marginBottom: theme.spacing(1.5),
  },
  tickText: {
    fontSize: 12,
    fontWeight: 'normal',
    marginInlineStart: theme.spacing(1),
    color: '#2b3940',
  },
  otherActions: {
    marginLeft: 'auto !important',
    marginRight: 'o !important',
  },
  otherActionsMenu: {
    border: '1px solid #d8d1d1',
  },
  otherActionsMenuItem: {
    padding: theme.spacing(1.5),
    color: 'gray',
    minWidth: 160,
    '&:hover': {
      color: theme.palette.info.main,
    },
  },
  expandBtn: {
    border: `1px solid #2b3990`,
    padding: theme.spacing(2),
    margin: 0,
    background: 'white',
    color: '#2b3990',
    '&:hover': {
      background: '#2b3990',
      color: '#fff',
      '& *': {
        stroke: '#fff',
      },
    },
  },
}));
